import VueTree from '@ssthouse/vue-tree-chart'
import Vue from 'vue'

Vue.component('VueTree', VueTree)